module.exports = __webpack_public_path__ + "img/GS_Profile-Andile Zalekil.afa8da58.png";